import {Injectable} from '@angular/core'
import {AuthService} from "../auth.service";
import { AppStorageService } from '../app-storage.service';
import { StorageKeys } from '../storage-keys';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  data = {
    token: Math.random().toString(),
    phone: '123456789',
    password: '123456',
    lastName: 'Nytelweb',
    publicProfile: {
      picture: '',
      username: 'Nytelweb',
      birthday: '',
      location: '',
      description: ''
    }
  }

  users: any[] = [
    {
      ...this.data,
      name: 'Usuario',
      email: 'usuario@correo.es'
    }
  ]

  appUsers = [
    {
      id: 0,
      name: 'User Name',
      phone: ''
    },
    {
      id: 1,
      name: 'User Name',
      phone: ''
    },
    {
      id: 0,
      name: 'Admin Name',
      phone: ''
    }
  ]

  constructor(
    private authService: AuthService,
    private storage: AppStorageService
  ) {
  }

  activeUser: any

  async setUser(newUser: any): Promise<any[]> {
    this.storage.setJSON(StorageKeys.USER, newUser)
    return this.getUser()
  }

  getUser() {
    return this.storage.getJSON(StorageKeys.USER) || {}
  }

  logout() {
    this.storage.set(StorageKeys.USER, '')
    this.storage.set(StorageKeys.TOKEN, '')
    this.storage.set(StorageKeys.GUEST, 'true')
    return this.authService.logout()
  }

  checkGuest() {
    return this.storage.getJSON<boolean>(StorageKeys.GUEST) || false
  }

  getAppUser() {
    return this.appUsers
  }

  addAppUser(user: any) {
    this.appUsers.push(user)
  }

  removeUser(index: any) {
    this.appUsers.splice(index, 1)
  }

  async getUserType() {
    const user = await this.getUser()
    return user.userType
  }

  async getCurrentPassword() {
    const user = await this.getUser()
    return user.password
  }

  async login(inputEmail: string, inputPassword: string) {
    const result = this.users.find(({email, password}) => email === inputEmail && password === inputPassword)
    if (result) {
      this.storage.setJSON(StorageKeys.USER, result)
      this.storage.set(StorageKeys.GUEST, 'false')
    }
    return result ? result : false
  }

  async setPublicProfile(data: any) {
    this.storage.setJSON(StorageKeys.PUBLIC_PROFILE, data)
  }
}
